import ToolEntryButton from '~/components/toolbar/shared/ToolEntryButton';
import { useRegistrationModeEntries } from './useRegistrationModeEntries';

interface RegistrationModeToolProps {
    isDisabled: boolean;
    /** Why the modes are unavailable, appended to their tooltips while disabled. */
    disabledReason?: string;
}

export default function RegistrationModeTool({
    isDisabled,
    disabledReason,
}: RegistrationModeToolProps) {
    const { translation, rotation } = useRegistrationModeEntries(
        isDisabled,
        disabledReason
    );

    return (
        <>
            <ToolEntryButton
                entry={translation}
                data-testid="registration-translate-mode"
            />
            <ToolEntryButton
                entry={rotation}
                data-testid="registration-rotate-mode"
            />
        </>
    );
}
